import React from 'react';

function ingredientName(name, warnings) {
	if (typeof name === 'string') {
		return <p>{name}</p>
	} else {
		const warning = matchWarnings(name, warnings)
		return <p className={warning? 'red': ''}>{Object.keys(name)}</p>;
	}
}

function matchWarnings(name, warnings) {
	const possibleWarnings = Object.values(name).toString().split(', ');
	for (let i = 0; i < possibleWarnings.length; i++) {
		const activeWarning = warnings[possibleWarnings[i]];
		if (activeWarning) {
			console.log(activeWarning);
			return true;
		}
	}
}

const IngredientList = ({
	ingredients,
	warnings,
}) => (
	<div>
		<div className="benefits">
			<p>Zutaten</p>
			{ingredients.length?

				<ul className="unformated-list">
					{ingredients.map((name, i) =>
						<li key={i} className="unformated-list__item">
							{ingredientName(name, warnings)}
						</li>
						)
					}
				</ul>:
				<p className="red">Nock keine eingetragen</p>
			}
		</div>
	</div>
);

export default IngredientList;


// WEBPACK FOOTER //
// ./src/detail/IngredientList.js